import { formatPerUnit } from './formatUnit';

/**
 * Dynamic-precision price formatter for commodity prices.
 *
 * Rules:
 *  - |value| >= 1       → 2 decimals        (e.g. 1,045.50)
 *  - 0.01 <= |value| < 1 → up to 5 decimals (e.g. 0.12345)
 *  - |value| < 0.01     → up to 9 decimals  (e.g. 0.000123456)
 *  - null / undefined / NaN → fallback string
 */
export function formatPrice(value, opts = {}) {
  const { locale = 'en-US', fallback = '—' } = opts;

  if (value == null || !Number.isFinite(value)) return fallback;

  const abs = Math.abs(value);
  let fractionOpts;

  if (abs >= 1) {
    fractionOpts = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  } else if (abs >= 0.01) {
    fractionOpts = { minimumFractionDigits: 2, maximumFractionDigits: 5 };
  } else {
    fractionOpts = { minimumFractionDigits: 2, maximumFractionDigits: 9 };
  }

  return value.toLocaleString(locale, fractionOpts);
}

/**
 * formatPrice + currency/unit suffix.
 * e.g. "1,045.50 USD/mt"
 */
export function formatPriceWithUnit(value, currency, unit, opts = {}) {
  const formatted = formatPrice(value, opts);
  if (formatted === (opts.fallback || '—')) return formatted;
  // Ohne Waehrung nur die Einheit, ohne Einheit nur die Waehrung ("n/a" zaehlt als leer).
  const suffix = formatPerUnit(currency, unit);
  return suffix ? `${formatted} ${suffix}` : formatted;
}
